import React from "react";
import TempleTimingsInfo from "./TempleTimingsInfo";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Timing() {
    const { t } = useTranslation();
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/thali.jpeg)', backgroundSize: 'cover', backgroundPosition: 'top' }}></div>

            <div className="container" style={{ backgroundImage: 'url(./images/thali-.jpeg)', marginTop: '100px', marginBottom: '100px', padding: '0px', backgroundSize: 'cover', backgroundAttachment: 'fixed', borderRadius: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* <TempleTimingsInfo /> */}



                <div class="container" style={{ margin: '50px', width: '80%' }}>
                    {/* <div class="header-">പൂജാ സമയം</div> */}
                    {/* <!-- Subrahmanya Temple --> */}
                    <div class="card-1">
                        <h2 style={{ fontFamily: 'manjari', fontSize: '22pt', fontWeight: '600' }}>Temple Timings </h2>

                        <div class="section-title">{t("mor")} </div>
                        <div class="time-row"><span>Temple opens, Abhishekam, Malar Nivedyam </span><span>04:30 AM</span></div>
                        <div class="time-row"><span>Dhara, Ushapuja </span><span>05:30 AM</span></div>
                        <div class="time-row"><span>Ganapathihomam</span><span>06:00 AM</span></div>
                        <div class="time-row"><span>Morning puja</span><span>06:30 AM</span></div>
                        <div class="time-row"><span>Sheeveli (Shiva kshetram) </span><span>07:00 AM</span></div>
                        <div class="time-row"><span>Sheeveli (Krishna kshetram)</span><span>07:15 AM</span></div>
                        <div class="time-row"><span>Navagraha puja, Mrutyunjaya homam </span><span>07:30 AM</span></div>
                        <div class="time-row"><span>Pantheeradi puja (Krishna kshethram)</span><span>08:00 AM</span></div>
                        <div class="time-row"><span>Lakshminarayana puja </span><span>08:30 AM</span></div>
                        <div class="time-row"><span>Pantheeradi puja (Shiva kshethram) </span><span>08:45 AM</span></div>
                        <div class="time-row"><span>Ucha puja (Krishna kshethram)</span><span>09:45 AM</span></div>
                        <div class="time-row"><span>Ucha puja (Shiva kshethram) </span><span>10:00 AM</span></div>
                        <div class="time-row"><span>Sheeveli (Krishna kshetram) </span><span>10:30 AM</span></div>
                        <div class="time-row"><span>Sheeveli (Shiva kshetram) </span><span>10:45 AM</span></div>
                        <div class="time-row"><span>Closes (Nada adaykkal) </span><span>11:00 AM</span></div>


                        <div class="section-title">{t("even")} </div>
                        <div class="time-row"><span>Opens (Nada Thurakkal) </span><span>05:00 PM</span></div>
                        <div class="time-row"><span>Deeparadhana</span><span>06:30 PM</span></div>
                        <div class="time-row"><span>Umamaheswara puja, Bhagavati seva </span><span>07:00 PM</span></div>
                        <div class="time-row"><span>Athazha puja </span><span>07:30 PM</span></div>
                        <div class="time-row"><span>Sheeveli (Krishna and Siva kshetram) </span><span>08:00 PM</span></div>
                        <div class="time-row"><span>Truppuka, nada adaykkal (closes) </span><span>08:30 PM</span></div>



                        <div class="highlight">
                            <u>Please note:</u>
                            <br />
                          Timing changes during festivals, Udayasthamana puja days
                        </div>
                    </div>

                    {/* <!-- Ayyappa Temple --> */}
                    {/* <div class="card-1">
                        <h2 style={{ fontFamily: 'manjari' }}>{t("ayyapat")} </h2>

                        <div class="section-title">{t("mor")} </div>
                        <div class="time-row"><span>{t("opm")} </span><span>04:30</span></div>
                        <div class="time-row"><span>{t("abkk")} </span><span>04:45 - 05:15</span></div>
                        <div class="time-row"><span>{t("ushpoo")} </span><span>06:00 - 06:30</span></div>
                        <div class="time-row"><span>{t("uchpoo")} </span><span>10:00 - 11:30</span></div>
                        <div class="time-row"><span>{t("nadad")} </span><span>12:30</span></div>

                        <div class="section-title">{t("even")} </div>
                        <div class="time-row"><span>{t("opm")} </span><span>04:30</span></div>
                        <div class="time-row"><span>{t("dheebef")} </span><span>07:00 - 07:30</span></div>
                        <div class="time-row"><span>{t("nadad")} </span><span>07:30</span></div>

                    </div> */}

                </div>


            </div>
        </div>
    );
}

export default Timing;